import { Box, Stack } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

export const RebookingLinksWrap: FC<PropsWithChildren<{ centered?: boolean }>> = ({
    children,
    centered = true,
}) => (
    <Stack flex={1} alignItems="center" {...(centered && { justifyContent: 'center' })}>
        <Box
            display="grid"
            width="100%"
            gap={{ xs: '12px', md: '24px' }}
            gridTemplateColumns={{
                xs: '1fr',
            }}
            padding={{
                xs: '24px 16px 32px 16px',
                md: '0 30px',
                lg: '0 60px',
            }}
        >
            {children}
        </Box>
    </Stack>
);
